import { Injectable } from '@angular/core';
import SimpleRenderer from '@arcgis/core/renderers/SimpleRenderer';
import SimpleFillSymbol from '@arcgis/core/symbols/SimpleFillSymbol';
import SimpleLineSymbol from '@arcgis/core/symbols/SimpleLineSymbol';
import SimpleMarkerSymbol from '@arcgis/core/symbols/SimpleMarkerSymbol';
import Color from '@arcgis/core/Color';

export interface LayerStyleConfig {
  fillEnabled: boolean;
  fillColor: string;
  strokeColor: string;
  strokeWidth: number;
}

@Injectable({ providedIn: 'root' })
export class LayerSymbolFactory {
  createRenderer(geometryType: string, style: LayerStyleConfig): SimpleRenderer {
    const outline = this.createOutline(style.strokeColor, style.strokeWidth);

    if (geometryType === 'polygon' || geometryType === 'multipatch') {
      return this.createPolygonRenderer(style.fillEnabled, style.fillColor, outline);
    }

    if (geometryType === 'polyline') {
      return this.createLineRenderer(outline);
    }

    return this.createPointRenderer(style.fillColor, outline);
  }

  private createOutline(color: string, width: number): SimpleLineSymbol {
    return new SimpleLineSymbol({ color: new Color(color), width });
  }

  private createPolygonRenderer(fillEnabled: boolean, color: string, outline: SimpleLineSymbol): SimpleRenderer {
    return new SimpleRenderer({
      symbol: new SimpleFillSymbol({
        color: fillEnabled ? new Color(color) : null as any,
        outline,
      }),
    });
  }

  private createLineRenderer(outline: SimpleLineSymbol): SimpleRenderer {
    return new SimpleRenderer({ symbol: outline });
  }

  private createPointRenderer(color: string, outline: SimpleLineSymbol): SimpleRenderer {
    return new SimpleRenderer({
      symbol: new SimpleMarkerSymbol({
        color: new Color(color),
        outline,
        size: 12,
        style: 'circle',
      }),
    });
  }
}
